<script>
	// Stores 
	import { 
		textSite,
		linkPesquisaVendas,
		linkPesquisaLocacao,

	} from '../store.js';  

	// Componentes
	import PageHeader                       from './../components/PageHeader.svelte';
	import { Router, Link, link , Route }   from "svelte-routing";
	import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

	// Code
	let titlePage = 'Quem somos';
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container clearfix text-justify">
		<p>Estamos há mais de 30 anos no mercado imobiliário da região metropolitana de Porto Alegre. E mais que crescermos em tamanho, nós evoluímos. Somos como os smartphones: compactos, mas com muita informação e facilidades ao seu alcance, o tempo inteiro. Colocamos todo o nosso conhecimento à sua disposição, de um jeito próximo, pessoal e sobretudo, ágil. Porque o seu tempo é curto e precioso, sabemos bem.</p>
		<p>Oferecemos a melhor assessoria para encontrar o imóvel dos seus sonhos. Damos a certeza da condição ideal para comprar, vender, alugar, ou colocar seu imóvel para locação. E garantimos a tranquilidade de décadas de experiência para administrar o seu condomínio. Muito prazer, somos a Dinmar Imóveis.</p>
	</div>
</section>